<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="业主姓名" prop="ownerName">
        <a-input v-model="form.ownerName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="业主电话" prop="ownerPhone">
        <a-input v-model="form.ownerPhone" placeholder="请输入" :maxLength="11" />
      </a-form-model-item>
      <template v-if="isShow">
        <a-form-model-item label="预约姓名" prop="reservationName">
          <a-input v-model="form.reservationName" placeholder="请输入" :maxLength="50" />
        </a-form-model-item>
        <a-form-model-item label="预约电话" prop="reservationPhone">
          <a-input v-model="form.reservationPhone" placeholder="请输入" :maxLength="11" />
        </a-form-model-item>
      </template>
      <a-form-model-item label="小区名称" prop="minAreaName">
        <a-input v-model="form.minAreaName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="预约时间" prop="reservationTime">
        <!-- <a-range-picker @change="onChange" v-model="form.reservationTimes" format="YYYY-MM-DD HH:mm" /> -->
        <a-range-picker
          @change="onChange"
          :show-time="{
            hideDisabledOptions: true,
          }"
          format="YYYY-MM-DD HH:mm"
        />
        <a-input v-model="form.reservationTime" placeholder="请输入" v-show="show" />
        <!-- <a-date-picker show-time placeholder="请选择" v-model="form.reservationTime" @change="onChange" /> -->
      </a-form-model-item>
      <!-- <template v-if="form.id">
        <a-form-model-item label="VR地址状态" prop="vrState">
          <a-radio-group v-model="form.vrState" button-style="solid">
            <a-radio-button :value="0"> 未配置 </a-radio-button>
            <a-radio-button :value="1"> 已配置 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="VR地址" prop="vrUrl">
          <a-input v-model="form.vrUrl" placeholder="请输入" :maxLength="50" />
        </a-form-model-item>
      </template> -->
      <a-form-model-item label="企业品牌" prop="tenantFirmId">
        <a-select
          show-search
          v-model="form.tenantFirmId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="handleTenant"
        >
          <a-select-option v-for="d in brandList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="经销商" prop="tenantAgentId">
        <a-select
          show-search
          v-model="form.tenantAgentId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="handleAgent"
        >
          <a-select-option v-for="d in agentList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="分销商" prop="tenantId">
        <a-select
          show-search
          v-model="form.tenantId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in distributionList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- <a-form-model-item label="分销商" prop="tenantId" v-else>
        <a-select
          show-search
          v-model="form.tenantId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in agentList" :key="d.userId">{{ d.userName }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item label="验收员" prop="pressureTestUserId">
        <a-select
          show-search
          v-model="form.pressureTestUserId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="handleChange"
        >
          <a-select-option v-for="d in inspector" :key="d.userId">{{ d.userName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="省市区" prop="area">
        <v-distpicker
          :province="form.province"
          :city="form.city"
          :area="form.area"
          @province="onChangeProvince"
          @city="onChangeCity"
          @area="onChangeArea"
        >
        </v-distpicker>
      </a-form-model-item>
      <a-form-model-item label="详细地址" prop="ownerAddress">
        <a-input v-model="form.ownerAddress" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <mapAdd ref="map" @getInfo="getInfo"></mapAdd>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj, tenantUser, addObj1, pageMy, recordPage } from '@/api/pressure/dispatch'
import mapAdd from '@/components/AMap/index'
import { listTenant, pageTenant } from '@/api/system/tenant'
import moment from 'moment'
import store from '@/store'
// import { getUser } from '@/api/biz/user'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: { mapAdd },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      show: false,
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        area: undefined,
        lat: undefined,
        log: undefined,
        minAreaName: undefined,
        ownerAddress: undefined,
        ownerName: undefined,
        ownerPhone: undefined,
        pressureTestName: undefined,
        pressureTestUserId: undefined,
        pressureTestUserPhone: undefined,
        province: undefined,
        remark: undefined,
        reservationTime: undefined,
        tenantAgentId: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
        waterUserId: undefined,
        reservationPhone: undefined,
        reservationName: undefined,
      },
      isShow: false,
      open: false,
      inspector: [],
      rules: {
        ownerPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        reservationPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        vrUrl: [{ required: true, message: '请输入VR 地址', trigger: 'blur' }],
        reservationName: [{ required: true, message: '请输入预约姓名', trigger: 'blur' }],
        tenantFirmId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
        // tenantAgentId: [{ required: true, message: '请选择代理商', trigger: 'blur' }],
        tenantId: [
          { required: true, message: '请选择分销商', trigger: 'blur' },
          { validator: validateQi, trigger: ['blur', 'change'] },
        ],
        minAreaName: [{ required: true, message: '请输入小区名称', trigger: 'blur' }],
        ownerName: [{ required: true, message: '请输入业主姓名', trigger: 'blur' }],
        pressureTestUserId: [{ required: true, message: '请选择验收员', trigger: 'blur' }],
        ownerAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        reservationTime: [{ required: true, message: '请选择预约时间', trigger: 'blur' }],
        area: [{ required: true, message: '请在地图上选择位置信息', trigger: 'blur' }],
      },
      superTube: '',
      agentList: [],
      brandList: [],
      distributionList: [],
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
    this.getUserList(0)
    this.getUser(0)
    console.log(store, '对对对对对对')
    this.superTube = store.getters.userTentant.type
    console.log(this.superTube, 'this.superTubethis.superTube')
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    tenantId() {
      return this.$store.state.user.userTentant.tenantId
    },
  },
  watch: {},
  methods: {
    // 企业品牌发生变化
    handleTenant(e) {
      console.log(e, '对对对对对对')
      this.getMy({ tenantIdUp: e, type: 2 }, 2)
    },
    // 经销商发生变化
    handleAgent(e) {
      this.getMy({ tenantIdUp: e, type: 2 }, 3)
    },
    // 查询经销商厂商
    getUser(e) {
      console.log(this.tenantId, 'this.tenantIdthis.tenantId')
      if (this.userType === 0) {
        // // 管理员 查询企业品牌
        this.getMy({ type: 1 }, 1)
      } else if (this.userType === 1) {
        // 企业品牌
        this.getMy({ tenantIdUp: this.tenantId, type: 2 }, 2)
      } else {
        // 经销商
        pageMy().then((res) => {
          console.log(res.data.records, '测试====')
          this.brandList = res.data.records
        })
        this.tenantId = store.getters.userTentant.tenantId
      }
    },
    getMy(query, e) {
      // 厂商经销商
      pageMy(query).then((res) => {
        console.log(res.data.records, '测试====666')
        if (e === 1) {
          this.brandList = res.data.records
        } else if (e === 2) {
          console.log()
          // 经销商
          this.agentList = res.data.records
        } else {
          // 分销商
          this.distributionList = res.data.records
        }
      })
    },
    // 查询验收和水工
    getUserList(type) {
      console.log(type, '测试数据====企业品牌啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪')
      tenantUser({ type: type, pageNum: 1, pageSize: 999 }).then((res) => {
        this.inspector = res.data.records
        console.log(res.data, 'res.datares.datares.data')
      })
    },
    // 验收员选择发生变化
    handleChange(e) {
      console.log(e, '的点点滴滴')
      this.inspector.forEach((v) => {
        if (v.userId === e) {
          this.form.pressureTestName = v.userName
          this.form.pressureTestUserPhone = v.userPhone
        }
      })
    },
    // 时间选择
    onChange(e) {
      console.log(e, '121212888')
      this.form.reservationTime =
        moment(e[0]).format('YYYY-MM-DD HH:mm') + '/' + moment(e[1]).format('YYYY-MM-DD HH:mm')
      console.log(this.form.reservationTime, 'this.form.reservationTime')
    },
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getInfo(e) {
      this.form.ownerAddress = e.detailedAddress
      this.form.lat = e.lat
      this.form.log = e.lng
      this.form.province = e.addressComponent.province
      this.form.city = e.addressComponent.city ? e.addressComponent.city : e.addressComponent.province
      this.form.area = e.addressComponent.district
      this.$forceUpdate()
      // console.log(e, 'ddddmm打得动');
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        area: undefined,
        lat: undefined,
        log: undefined,
        minAreaName: undefined,
        ownerAddress: undefined,
        ownerName: undefined,
        ownerPhone: undefined,
        pressureTestName: undefined,
        pressureTestUserId: undefined,
        pressureTestUserPhone: undefined,
        province: undefined,
        remark: undefined,
        reservationTime: undefined,
        tenantAgentId: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
        waterUserId: undefined,
      }
      this.tags = []
      this.tagslist = []
    },
    // 点击提交型号口径
    handleModelAdd() {
      if (this.form.modelCaliberAddParams.length === 0) {
        this.form.modelCaliberAddParams.push({ name: '', sort: '' })
      } else {
        const index = this.form.modelCaliberAddParams.length - 1
        if (!this.form.modelCaliberAddParams[index].name) return this.$message.error('请输入口径名称')
        if (!this.form.modelCaliberAddParams[index].sort) return this.$message.error('请输入口径排序')
        this.form.modelCaliberAddParams.push({ name: '', sort: '' })
      }
    },
    handleModelDel(index) {
      this.form.modelCaliberAddParams.splice(index, 1)
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      const name = this.$route.name
      console.log(name, 'namenamename')
      if (name === 'DispatchOne') {
        this.formTitle = '添加预约订单'
        this.isShow = true
      } else {
        this.formTitle = '添加订单'
        this.isShow = false
      }

      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        console.log(response, 'responseresponse')
        // console.log(response.data, 'response.data')
        // // this.tagslist = response.data.productCode.split(',')
        // this.tags = response.data.optionalUnit.split(',')
        // response.data.modelCaliberAddParams = response.data.modelCalibers
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            const query = JSON.parse(JSON.stringify(this.form))
            // if (this.userType === 0) {
            //   if (!query.tenantFirmId) {
            //     query.tenantFirmId = this.tenantId
            //     query.tenantAgentId = this.tenantId
            //     query.tenantId = this.tenantId
            //   } else if (!query.tenantAgentId) {
            //     query.tenantAgentId = query.tenantFirmId
            //     query.tenantId = query.tenantFirmId
            //   } else if (!query.tenantId) {
            //     query.tenantId = query.tenantAgentId
            //   }
            // }
            addObj1(query)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
